module.exports = __webpack_public_path__ + "img/product-placeholder-43.c2ee3b6.png";